module.exports = __webpack_public_path__ + "assets/img/step9-sz.89ffa27f.png";